export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              实时更新中
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight text-balance">
              911吃瓜网 - 第一手热门爆料平台
            </h1>

            <p className="mt-3 text-lg md:text-xl text-primary-600 font-heading font-semibold">
              今日吃瓜，从这里开始
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-[600px] mx-auto lg:mx-0">
              911吃瓜网聚焦全网最新热点事件，覆盖娱乐八卦、社会热议、网红动态等多元话题领域，每日追踪第一手热门爆料，实时更新今天吃瓜与今日八卦资讯。无论是最新热点深度解析，还是每日吃瓜即时推送，我们都致力于为你呈现最鲜活、最全面的吃瓜内容，让你不错过任何一个精彩瞬间。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-6">
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading font-bold text-primary-600">200+</span>
                <span className="text-xs md:text-sm text-foreground-500">条/日实时更新</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading font-bold text-accent-600">50+</span>
                <span className="text-xs md:text-sm text-foreground-500">话题领域覆盖</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl md:text-3xl font-heading font-bold text-secondary-600">7×24</span>
                <span className="text-xs md:text-sm text-foreground-500">小时不间断追踪</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-7">
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-colors whitespace-nowrap text-sm"
              >
                立即吃瓜
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 hover:bg-background-100 text-foreground-700 font-medium rounded-full border border-background-300 transition-colors whitespace-nowrap text-sm"
              >
                投稿爆料
                <i className="ri-send-plane-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[420px] aspect-[4/5] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20entertainment%20news%20visual%20collage%20with%20warm%20red%20and%20gold%20gradient%20tones%2C%20abstract%20geometric%20shapes%20representing%20trending%20topics%2C%20dynamic%20magazine%20editorial%20style%2C%20glowing%20particles%20and%20light%20effects%2C%20dark%20background%20with%20warm%20illuminated%20elements%2C%20high-end%20gossip%20media%20aesthetic%2C%20luxurious%20and%20dramatic%20composition&width=840&height=1050&seq=hero-visual-01&orientation=portrait"
                alt="911吃瓜网今日热点爆料视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}